import axios, { getVariable } from "./api";
import { keycloak } from "../components/auth";

export const getRanking = async (type) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + "/v1/ranking/" + type,
    headers
  );
};
